import { FunctionComponent } from 'react';
import StarIcon from '@mui/icons-material/Star';
import styles from './PatientReviewItem.module.css';

interface PatientReviewItemProps {
  reviewerName: string;
  reviewDate: string;
  rating: number;
  reviewText: string;
  verified?: boolean;
}

const PatientReviewItem: FunctionComponent<PatientReviewItemProps> = ({
  reviewerName,
  reviewDate,
  rating,
  reviewText,
  verified = false
}) => {
  return (
    <div className={styles.reviewItem}>
      <div className={styles.reviewHeader}>
        <div className={styles.reviewerInfo}>
          <span className={styles.reviewerName}>{reviewerName}</span>
          <span className={styles.reviewDate}>{reviewDate}</span>
          {verified && <span className={styles.verifiedBadge}>Verified Patient</span>}
        </div>
        <div className={styles.reviewRating}>
          {[1, 2, 3, 4, 5].map((star) => (
            <StarIcon 
              key={star} 
              className={star <= rating ? styles.starFilled : styles.starEmpty}
            />
          ))}
        </div>
      </div>
      <p className={styles.reviewText}>{reviewText}</p>
    </div>
  );
};

export default PatientReviewItem;